import { ISelectOption } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import { SurveyType } from '../models';

export const SurveyTypeEnumHelper = {
	getSurveyTypeAsSelectOptions(): ISelectOption[] {
		const surveyTypes = Object.keys(SurveyType).filter((key) => {
			return isNaN(Number(key));
		});
		return _.map(surveyTypes, (s: string, counter: number) => {
			return {
				name: s,
				displayText: s,
				displayOrder: counter + 1,
				disabled: false,
			};
		});
	},
	getSurveyTypeFlagsAsArray(value: SurveyType): SurveyType[] {
		/*
            Used to determine which flags have been selected. 
            An easy way to picture this is with binary to represent each SurveyType.
            000 = None (Not implemented)
            001 = Engagement
            010 = Culture
            011 = Engagement and Culture (Not explicitly defined by the enum, but can be derived here)
        */
		// tslist:disable no-bitwise
		return [SurveyType.Engagement, SurveyType.Culture].filter((surveyType, number) => value & (1 << number));
		// tslint:enable no-bitwise
	},
	getSurveyTypeStringValues(value: SurveyType | undefined): string[] | undefined {
		if (value === undefined) {
			return undefined;
		} else {
			const flags = this.getSurveyTypeFlagsAsArray(value);
			const strings: string[] = [];
			flags.forEach((s) => strings.push(SurveyType[s]));
			return strings;
		}
	},
};
